module.exports = __webpack_public_path__ + "media/4386-connection-error.2b0c3e5e.mp4";